module.exports = __webpack_public_path__ + "media/iconic/check-8549fa8e.svg";